import React from "react";
import { toast } from "react-toastify";

// Copy / share / print for a gift card. "Print" also covers saving as PDF
// (the browser's print dialog offers "Save as PDF"); print CSS limits the
// page to the card itself.
export default function GiftCardActions({ code, redeemUrl }) {
  const copy = (text, message) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(() => toast.success(message)).catch(() => toast.error("Could not copy."));
    } else {
      toast.info(text);
    }
  };

  const share = () => {
    const text = `You've been given a VerySoul Experience! Your Gift Code: ${code}`;
    if (navigator.share) {
      navigator.share({ title: "A VerySoul Experience for you", text, url: redeemUrl }).catch(() => {});
    } else {
      copy(`${text}\n${redeemUrl}`, "Gift message copied. Paste it wherever you'd like to share it.");
    }
  };

  return (
    <div className="vsr-actions vsr-card-actions no-print">
      <button type="button" className="vsr-btn vsr-btn-outline" onClick={() => copy(code, "Gift Code copied.")}>
        Copy Gift Code
      </button>
      <button type="button" className="vsr-btn vsr-btn-outline" onClick={share}>
        Share Gift
      </button>
      <button type="button" className="vsr-btn vsr-btn-outline" onClick={() => window.print()}>
        Print / Save as PDF
      </button>
    </div>
  );
}
